import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tabs, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import CustomerSupportList from "../../features/manageCustomerSupport/customerSupportList";
import { SupportItem, useLazyGetSupportQuery } from "../../services/customerSupport";
import { showError } from "../../constants/toasts";
import { isValidInput } from "../../utils/validations";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomerSupport = () => {
  const navigate = useNavigate();

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs1(newValue);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [getSupport] = useLazyGetSupportQuery()
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pendingRows, setPendingRows] = useState<SupportItem[]>([]);
  const [resolvedRows, setResolvedRows] = useState<SupportItem[]>([]);
  const [pendingTotal, setPendingTotal] = useState(0);
  const [resolvedTotal, setResolvedTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const fetchCustomerSupport = async (status: "PENDING" | "APPROVED") => {
    try {
      setLoading(true);
      const response = await getSupport({
        from: page,
        size: pageSize,
        search: debouncedSearchTerm,
        status
      }).unwrap();

      if (response?.statusCode === 200) {
        if (status === "PENDING") {
          setPendingRows(response.data.data || []);
          setPendingTotal(response.data.total || 0);
        } else {
          setResolvedRows(response.data.data || []);
          setResolvedTotal(response.data.total || 0);
        }
      }
    } catch (error: any) {
      showError(error?.data?.message || "Failed to fetch Customer Support");
    }
    finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const activeStatus: "PENDING" | "APPROVED" = valueTabs1 === 0 ? "PENDING" : "APPROVED";
    fetchCustomerSupport(activeStatus);
  }, [valueTabs1, page, pageSize, searchTerm])

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Customer Support</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Customer Support
        </p>
      </div>

      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs1}
            onChange={handleChangeTabs1}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Pending" {...a11yProps(0)} />
            <Tab label="Resolved" {...a11yProps(1)} />
          </Tabs>

          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  placeholder="Search..."
                  searchTerm={searchTerm}
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
          </div>
          <CustomTabPanel value={valueTabs1} index={0}>
            <CustomerSupportList
              fetchCustomerSupport={() => fetchCustomerSupport("PENDING")}
              rows={pendingRows}
              total={pendingTotal}
              loading={loading}
              statusTab="PENDING"
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs1} index={1}>
            <CustomerSupportList
              fetchCustomerSupport={() => fetchCustomerSupport("APPROVED")}
              rows={resolvedRows}
              total={resolvedTotal}
              loading={loading}
              statusTab="APPROVED"
            />
          </CustomTabPanel>
        </Box>
      </div>
    </MainContainer>
  );
};

export default ManageCustomerSupport;
